// @flow

import { connect } from "react-redux";
import React from "react";

import { MenuItem, Value } from "./styles";
import defaultStatus, * as status from "src/constants/status";
import { getChatroomStatus } from "src/reducers";

import type { AppState } from "src/types";

type Props = {
  value: number,
  handleStatus: Function
};

const Group = ({ value, handleStatus }: Props) => {
  const pending = defaultStatus[status.PENDING];
  const canceled = defaultStatus[status.CANCELED];

  return (
    <>
      <MenuItem
        tabIndex="0"
        role="button"
        onClick={() => handleStatus(status.PENDING)}
        onKeyPress={() => handleStatus(status.PENDING)}
      >
        <Value color={pending.color} textColor={pending.textColor}>
          {status.ACTIVE}
        </Value>
        <span
          dangerouslySetInnerHTML={{
            __html: `${value === status.PENDING ? "&#10004;" : ""}`
          }}
        />
      </MenuItem>

      <MenuItem
        tabIndex="0"
        role="button"
        onClick={() => handleStatus(status.CANCELED)}
        onKeyPress={() => handleStatus(status.CANCELED)}
      >
        <Value color={canceled.color} textColor={canceled.textColor}>
          {canceled.text}
        </Value>
        <span
          dangerouslySetInnerHTML={{
            __html: `${value === status.CANCELED ? "&#10004;" : ""}`
          }}
        />
      </MenuItem>
    </>
  );
};

const mapStateToProps = ({ app }: { app: AppState }, props) => ({
  value: getChatroomStatus(app, props.roomId)
});

export default connect(mapStateToProps)(Group);
